






























import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import { rdb } from '../../firebase/init'
import { RdbUserType, UserType } from '../../types'

@Component({
  components: {
  },
})
export default class Chat extends Mixins(MainMixin) {
  get tabs() {
    if (this.$store.getters.manager) {
      return [{ title: 'Send', value: 'send' }, { title: 'Managers', value: 'managers' }]
    } return undefined
  }

  groupChat = true

  message = ''

  get participants() {
    return this.$store.state.appStore.dbUsers.map((user:RdbUserType) => {
      console.log('doing user: ', user)
      return {
        id: user['.key'],
        name: this.getUserName(user['.key']),
        imageUrl: `https://firebasestorage.googleapis.com/v0/b/canvas-forms-profiles/o/profiles%2F${user['.key'] || ''}_70x70.png?alt=media`,
      }
    })
  }
  // {
  //   id: 'chris@canvasrestaurantconsultants_com',
  //   name: 'Chris Gienko',
  //   imageUrl: `https://firebasestorage.googleapis.com/v0/b/canvas-forms-profiles/o/profiles%2F${this.$store.getters.uid || ''}_70x70.png?alt=media`,
  // },\

  titleImageUrl = `https://firebasestorage.googleapis.com/v0/b/canvas-forms-profiles/o/profiles%2F${this.$store.getters.uid || ''}_70x70.png?alt=media`

  // messageList = [
  //   { type: 'text', author: 'me', data: { text: 'Say yes!' } },
  //   { type: 'text', author: 'user1', data: { text: 'No.' } },
  // ]

  groupMessages:any[] = []

  managementMessages:any[] = []

  get messageList() {
    const messages = this.groupChat ? this.groupMessages : this.managementMessages
    return messages.map((message:any) => ({
      author: message.user === this.$store.getters.uid ? 'me' : message.user,
      type: message.type,
      data: {
        text: message.text,
        meta: this.relativeTime(new Date(message.created)),
      },
    }))
  }

  colors = {
    header: {
      bg: '#4e8cff',
      text: '#ffffff',
    },
    launcher: {
      bg: '#4e8cff',
    },
    messageList: {
      bg: '#ffffff',
    },
    sentMessage: {
      bg: '#4e8cff',
      text: '#ffffff',
    },
    receivedMessage: {
      bg: '#eaeaea',
      text: '#222222',
    },
    userInput: {
      bg: '#f4f7f9',
      text: '#565867',
    },
  }

  get newMessagesCount() {
    return this.messageData.management.newCount + this.messageData.group.newCount
  }

  isChatOpen = false // to determine whether the chat window should be open or closed

  get showTypingIndicator() {
    if (this.groupChat && this.groupTyping.typing && this.groupTyping.user !== this.$store.getters.uid) return this.groupTyping.user
    if (!this.groupChat && this.managementTyping.typing && this.managementTyping.user !== this.$store.getters.uid) return this.managementTyping.user
    return ''
  }

  messageStyling = true

  test() {
    console.log(this.managementMessages[0]['.key'])
  }

  async onMessageWasSent(message:any) {
    console.log('message is: ', message)
    // called when the user sends a message
    await rdb.ref(`locations/${this.$store.getters.location}/messages/${this.groupChat ? 'group' : this.$store.getters.uid}`).push({
      // @ts-ignore
      user: this.$store.getters.uid,
      type: message.type,
      text: message.data.text,
      created: firebase.database.ServerValue.TIMESTAMP,
    });
    // this.messageList = [...this.messageList, message]
  }

  messageData = {
    group: {
      newCount: 0,
      lastMessage: '',
    },
    management: {
      newCount: 0,
      lastMessage: '',
    },
  }

  newGroupMessagesCount = 0

  openChat() {
    // called when the user clicks on the fab button to open the chat
    this.isChatOpen = true
    if (!this.newGroupMessagesCount) {
      this.groupChat = false
      this.messageData.group.newCount = 0
      this.messageData.group.lastMessage = this.groupMessages[this.groupMessages.length - 1]['.key']
    } else {
      this.groupChat = true
      this.messageData.management.newCount = 0
    }
  }

  closeChat() {
    // called when the user clicks on the botton to close the chat
    this.isChatOpen = false
  }

  handleScrollToTop() {
    // called when the user scrolls message list to top
    // leverage pagination for loading another page of messages
  }

  get isTyping() {
    if (this.groupChat) return this.groupTyping
    return this.managementTyping
  }

  groupTyping = { typing: false, user: '' }

  managementTyping = { typing: false, user: '' }

  handleOnType() {
    console.log('typing')
    if (this.groupChat) {
      if (!this.groupTyping.typing) {
        console.log('going here')
        this.groupTypingRef.set({
          typing: true,
          user: this.$store.getters.uid,
        })
        setTimeout(() => {
          if (this.groupTyping.user === this.$store.getters.uid) {
            this.groupTypingRef.set({
              typing: false,
              user: '',
            })
          }
        }, 5000)
      }
    } else if (!this.managementTyping.typing) {
      console.log('going here MMM')
      this.managementTypingRef.set({
        typing: true,
        user: this.$store.getters.uid,
      })
      setTimeout(() => {
        if (this.managementTyping.user === this.$store.getters.uid) {
          this.managementTypingRef.set({
            typing: false,
            user: '',
          })
        }
      }, 5000)
    }
  }

  writeMessage(to:string, text:string) {
    console.log('ok sending')
    const created = new Date().toISOString()
    return rdb.ref(`locations/${this.$store.getters.location}/messages/${this.groupChat ? 'group' : this.$store.getters.uid}`).push({
      user: this.$store.getters.uid,
      text,
      created,
    });
  }

  allMessages = []

  @Watch('groupMessages')
  newGroupMessage(newMessage:any) {
    if (!this.isChatOpen || !this.groupChat) {
      this.messageData.group.newCount += 1
    }
  }

  @Watch('managementMessages')
  newManagementMessage(newMessage:any) {
    if (!this.isChatOpen || this.groupChat) {
      this.messageData.management.newCount += 1
    }
  }

  created() {
    this.$rtdbBind('groupMessages', this.groupMessagesRef)
    this.$rtdbBind('managementMessages', this.managementMessagesRef)
    this.$rtdbBind('groupTyping', this.groupTypingRef)
    this.$rtdbBind('managementTyping', this.managementTypingRef)
  }

  get groupMessagesRef() { return rdb.ref(`locations/${this.$store.getters.location}/messages/group`) }

  get managementMessagesRef() { return rdb.ref(`locations/${this.$store.getters.location}/messages/${this.$store.getters.uid}`) }

  get groupTypingRef() { return rdb.ref(`locations/${this.$store.getters.location}/messages/typing`).child('group') }

  get managementTypingRef() { return rdb.ref(`locations/${this.$store.getters.location}/messages/typing`).child(this.$store.getters.uid) }

  get userRef() { return rdb.ref(`locations/${this.$store.getters.location}/users/${this.$store.getters.uid}`) }
}

